import {combineReducers} from 'redux';
import {routerReducer} from './routerContext';
import appReducer from 'modules/reducer';

export default combineReducers({
    router: routerReducer,
    app: appReducer,
});

